// extracted by mini-css-extract-plugin
export var gridCallout = "gridCallout-module--gridCallout--Dl5Vr";
export var imgWrap = "gridCallout-module--imgWrap--U6m4T";
export var imageLink = "gridCallout-module--imageLink--vDHlb";
export var textTransformer = "gridCallout-module--textTransformer--QBWRT";
export var calloutImage = "gridCallout-module--calloutImage--+T8-m";
export var videoWrapper = "gridCallout-module--videoWrapper--t2jKh";
export var indicatorlabel = "gridCallout-module--indicatorlabel--qp9kz";
export var indicatorLine = "gridCallout-module--indicatorLine--X2E0R";
export var link = "gridCallout-module--link--HhmZv";
export var calloutInner = "gridCallout-module--calloutInner--evubO";
export var alignRight = "gridCallout-module--alignRight--QcK0a";
export var withOutText = "gridCallout-module--withOutText--EVE+e";
export var calloutText = "gridCallout-module--calloutText--MmP-4";
export var withText = "gridCallout-module--withText--Y8OQS";
export var alignLeft = "gridCallout-module--alignLeft--AV0FD";
export var normal = "gridCallout-module--normal--PPA+7";
export var large = "gridCallout-module--large--97NLO";
export var tall = "gridCallout-module--tall--dtNDm";
export var verticalAlignBottom = "gridCallout-module--vertical-align-bottom--Jfc1M";
export var calloutTitle = "gridCallout-module--calloutTitle--0bD4R";
export var calloutButton = "gridCallout-module--calloutButton--bBzpA";
export var slideUp = "gridCallout-module--slideUp--WcDKn";
export var slideUpLarge = "gridCallout-module--slideUpLarge--ou04j";